/* eslint-disable extra-rules/no-commented-out-code */
// 9fbef606107a605d69c0edbcd8029e5d
/* eslint-disable max-statements */
/* eslint-disable sonarjs/cognitive-complexity */
import logger from '@tcp/core/src/utils/loggerInstance';
import { SEARCH_REDIRECT_KEY, getSearchRedirectObj, routerReplace } from '@tcp/core/src/utils';
import processHelpers from './processHelpers';
import {
  routerPush,
  getSiteId,
  isCanada,
  setSessionStorage,
  configureInternalNavigationFromCMSUrl,
  isClient,
} from '../../../utils';
import { getSeoHeaderCopyFromBreadCrumb } from '../../../components/features/browse/ProductListing/container/ProductListing.util';
import { getCategoryId, parseProductInfo, checkIfBundleProduct } from './productParser';
import { FACETS_FIELD_KEY } from './productListing.utils';
import {
  getProductsFilters,
  getTotalProductsCount,
  getCurrentListingIds,
} from '../../../components/features/browse/ProductListing/container/ProductListing.selectors';
import { SLASH_C_PATH, SLASH_C_ROUTE } from '../../../constants/plp.constants';
import { isShopThisStoreModeOn } from '../../../reduxStore/selectors/session.selectors';
import { getCurrentFeatureBrandAttribute } from '../../../components/features/browse/SearchDetail/container/SearchDetail.util';
import { getQuickFilters } from '../../../components/features/browse/QuickFilters/utils';
// import { getLocalStorage } from '../../../utils/localStorageManagement';

const getAvailableL3List = (facets) => {
  return facets && facets.multilevel && facets.multilevel.bucket;
};
const getAppliedL3Filters = (availableL3List) => {
  return availableL3List && availableL3List.length && (availableL3List[0].values || []);
};
const isUnbxdLogicApplied = (shouldApplyUnbxdLogic, bucketingSeqConfig) => {
  return shouldApplyUnbxdLogic && bucketingSeqConfig.bucketingRequired;
};
const getCurrentListingId = (breadCrumbs) => {
  return breadCrumbs && breadCrumbs.length ? breadCrumbs[breadCrumbs.length - 1].urlPathSuffix : '';
};
const getCurrentListingDescription = (breadCrumbs) => {
  return breadCrumbs && breadCrumbs.length
    ? breadCrumbs[breadCrumbs.length - 1].longDescription
    : '';
};
const getCurrentListingType = (breadCrumbs) => {
  return breadCrumbs && breadCrumbs.length ? breadCrumbs[breadCrumbs.length - 1].displayName : '';
};
const getIsBopisFilterOn = (filters) => {
  return filters && filters.bopisStoreId ? filters.bopisStoreId.length > 0 : false;
};
const getOutfitStyliticsTag = (isOutfitPage, searchTerm) => {
  return isOutfitPage ? searchTerm : null;
};

const isDepartmentPage = (isSearch, breadCrumbs) => {
  return !isSearch && (!breadCrumbs || breadCrumbs.length === 1);
};
const isCategoryType = (breadCrumbs) => {
  return breadCrumbs && breadCrumbs.length ? breadCrumbs[breadCrumbs.length - 1].displayName : '';
};
const getL1Category = (breadCrumbs) => {
  return breadCrumbs && breadCrumbs.length ? breadCrumbs[0].displayName : '';
};

/**
 * Checks if all arrays in the given object are empty.
 *
 * @param {Object} obj - The object with arrays as values.
 * @returns {boolean} - Returns true if all arrays are empty, false otherwise.
 */
export const isAppliedFitersObjectEmpty = (obj) => {
  // Ensure the input is an object
  if (typeof obj !== 'object' || obj === null) {
    throw new TypeError('Input must be a non-null object');
  }

  // Iterate over the object's keys and check if all arrays are empty
  return Object.values(obj).every((value) => Array.isArray(value) && value.length === 0);
};

// Function to separate an object into filtered and remaining keys
const separateKeys = (obj) => {
  const quickFilterModuleObj = {};
  const sidebarFilterObj = {};
  const quickFiltersObj = {};
  let quickFilterParam = '_h_uFilter';
  let moduleFilterParam = '_m_uFilter';
  Object.keys(obj).forEach((key) => {
    if (key.includes('_H_uFilter')) {
      quickFilterParam = '_H_uFilter';
    }
    if (key.includes('_M_uFilter')) {
      moduleFilterParam = '_M_uFilter';
    }
    if (key?.toLowerCase().includes('_h_ufilter')) {
      quickFiltersObj[key] = obj[key];
    } else if (key?.toLowerCase().includes('_m_ufilter')) {
      quickFilterModuleObj[key] = obj[key];
    } else {
      sidebarFilterObj[key] = obj[key];
    }
  });
  // Retain only the first two keys in quickFilterModuleObj
  const filteredQuickFilterModuleObj = Object.keys(quickFilterModuleObj)
    .slice(0, 2)
    .reduce((acc, key) => {
      acc[key] = quickFilterModuleObj[key];
      return acc;
    }, {});
  const modifiedObj = getQuickFilters(
    filteredQuickFilterModuleObj,
    sidebarFilterObj,
    obj,
    moduleFilterParam
  );
  const quickFilters = getQuickFilters(quickFiltersObj, sidebarFilterObj, obj, quickFilterParam);
  return { quickFilterModuleObj: modifiedObj, sidebarFilterObj, quickFilters };
};

export const getModuleFilters = (filters) => {
  const { quickFilterModuleObj } = separateKeys(filters);

  return quickFilterModuleObj;
};

export const extractQuickFiltersFromFilters = (filters) => {
  const { quickFilters } = separateKeys(filters);
  return quickFilters;
};

export const getFiltersAfterProcessing = (
  facetsRes,
  numberOfProducts,
  getFacetSwatchImgPath,
  filtersAndSort,
  l1category,
  toggleSearchSizeFilter,
  stats,
  isCleanUrlForSizeEnabled
) => {
  let filters = {};
  // Construct facets from the api response
  const facetsList = facetsRes && facetsRes.text && facetsRes.text.list && facetsRes.text.list;
  if (facetsList) {
    const facets = processHelpers.getFacetsAPIData(
      facetsList,
      getFacetSwatchImgPath,
      numberOfProducts,
      filtersAndSort,
      toggleSearchSizeFilter,
      isCleanUrlForSizeEnabled
    );
    const unbxdDisplayName = processHelpers.getUnbxdDisplayName(facetsList);

    const newPriceRange = stats?.min_offer_price;
    filters = {
      ...facets,
      unbxdDisplayName, // Key Value object added for Facets DisplayName and FacetName mapping in UI components
      l1category,
      newPriceRange,
    };
  }

  return filters;
};

export const hasSelectedFacets = (facets) => {
  const { text } = facets || {};
  if (text) {
    if (Object.prototype.hasOwnProperty.call(text, 'selected')) {
      return true;
    }

    return false;
  }
  return false;
};

const getQueryString = (keyValuePairs = {}) => {
  const params = [];
  // eslint-disable-next-line no-restricted-syntax
  for (const key of Object.keys(keyValuePairs)) {
    if (keyValuePairs[key] === null) {
      params.push(encodeURIComponent(key));
    } else {
      // eslint-disable-next-line no-lonely-if
      if (Array.isArray(keyValuePairs[key])) {
        // eslint-disable-next-line no-restricted-syntax
        for (const value of keyValuePairs[key]) {
          params.push([encodeURIComponent(key), '[]=', encodeURIComponent(value)].join(''));
        }
      } else {
        params.push(
          [encodeURIComponent(key), '=', encodeURIComponent(keyValuePairs[key])].join('')
        );
      }
    }
  }
  return params.join('&');
};

// const culteredFilter = (filters) => {
//   const updatedFilter = filters;
//   delete updatedFilter.action;
//   delete updatedFilter.min_offer_price;
//   return updatedFilter;
// };

// const evalAppliedFilters = (filtersAndSort) => {
//   const isPriceRemoveAction = filtersAndSort?.action ==='rm_price';
//     let appliedFiltersAndShorts = filtersAndSort;
//     if ( isPriceRemoveAction ) {
//       const prevSelectedFilter = JSON.parse(getLocalStorage('appliedFilters')) || null;
//       if (prevSelectedFilter) {
//         appliedFiltersAndShorts = culteredFilter(prevSelectedFilter);
//       } else {
//         appliedFiltersAndShorts = culteredFilter(filtersAndSort);
//       }
//     }
//     return appliedFiltersAndShorts;
// };

// eslint-disable-next-line sonarjs/cognitive-complexity
const getPlpUrlQueryValues = (filtersAndSort, location) => {
  // NOTE: these are parameters on query string we don't handle (nor we need to)
  // just pass them to the abstractor
  let urlQueryValues = {};
  let routeURL = '?';
  if (filtersAndSort) {
    // const appliedFilters = evalAppliedFilters(filtersAndSort);
    const { sort } = filtersAndSort;
    Object.keys(filtersAndSort)
      .sort()
      .forEach((key) => {
        if (filtersAndSort[key].length > 0) {
          if (key.toLowerCase() === FACETS_FIELD_KEY.sort) {
            // this also covers the fake sort describing the default server sort (which we give a falsy value like 0)
            if (isShopThisStoreModeOn() && Array.isArray(sort) && sort?.length > 0) {
              const [firstSortValue] = sort;
              urlQueryValues.sort = firstSortValue;
            } else {
              urlQueryValues.sort = sort;
            }
          } else {
            urlQueryValues[key] = filtersAndSort[key].join(',');
          }
        }
      });

    Object.keys(filtersAndSort)
      .sort()
      .forEach((key) => {
        if (
          (key.toLowerCase() === FACETS_FIELD_KEY.sort &&
            urlQueryValues.sort &&
            filtersAndSort.sort === '') ||
          (urlQueryValues[key] && filtersAndSort[key].length < 1)
        ) {
          // If sort has no value or recommended then no need to pass key in url and api
          delete urlQueryValues[key];
        }
        if (key === 'page' && urlQueryValues[key] === '1') {
          delete urlQueryValues[key];
        }
      });
  }

  urlQueryValues = getQueryString(urlQueryValues);

  let displayPath = typeof window === 'undefined' ? location.pathname : window.location.pathname;
  const searchName = typeof window === 'undefined' ? location.search || '' : window.location.search;
  displayPath = `${displayPath}${searchName}`;
  const country = getSiteId();
  let urlPath = displayPath.replace(`/${country}`, '');
  urlPath = urlPath.split('?');
  urlPath = [...urlPath].shift();

  // TODO- To get query from getInitialProps.
  let urlPathCID = urlPath.split('/');
  urlPathCID = urlPathCID[urlPathCID.length - 1];
  urlPathCID = urlPathCID.split('?');
  urlPathCID = [...urlPathCID].shift();

  routeURL = `${routeURL}${urlQueryValues}`;

  routeURL = `${urlPath}${routeURL}`;

  routeURL = urlQueryValues === '' ? routeURL.substring(0, routeURL.length - 1) : routeURL;
  if (routeURL.includes('search')) {
    routerPush(`/search?searchQuery=${urlPathCID}`, routeURL, { shallow: true }, undefined, {
      scroll: false,
    });
  } else if (routeURL.includes(SLASH_C_ROUTE)) {
    routerPush(`${SLASH_C_PATH}cid=${urlPathCID}`, routeURL, { shallow: true }, undefined, {
      scroll: false,
    });
  } else if (routeURL.includes('featurebrand')) {
    const updatedQueryValues = urlQueryValues
      ?.split('&')
      ?.filter((val) => !val.includes(getCurrentFeatureBrandAttribute(filtersAndSort)))
      .join('&');
    if (updatedQueryValues) {
      routerPush(
        `/featurebrand?brand=${urlPathCID}`,
        `${urlPath}?${updatedQueryValues}`,
        { shallow: true },
        undefined,
        {
          scroll: false,
        }
      );
      return `${urlPath}?${updatedQueryValues}`;
    }
    routerPush(`/featurebrand?brand=${urlPathCID}`, urlPath, { shallow: true }, undefined, {
      scroll: false,
    });
    return urlPath;
  }
  return routeURL;
};

function isFiltered(filtersAndSort) {
  let isFilterApplied = false;
  if (filtersAndSort) {
    Object.keys(filtersAndSort).forEach((key) => {
      if (filtersAndSort[key].length > 0 && key.toLowerCase() !== FACETS_FIELD_KEY.sort) {
        isFilterApplied = true;
      }
    });
  }
  return isFilterApplied;
}

function getProductCategory(res) {
  let productCategory = '';
  const products =
    res && res.response && res.response.products && res.response.products.length
      ? res.response.products
      : [];

  if (
    products.length &&
    products[0].categoryPath2_catMap &&
    products[0].categoryPath2_catMap.join().toLowerCase().includes('accessories')
  ) {
    productCategory = 'accessories';
  } else if (
    products.length &&
    products[0].categoryPath2_catMap &&
    products[0].categoryPath2_catMap.join().toLowerCase().includes('shoes')
  ) {
    productCategory = 'shoes';
  } else {
    productCategory = 'apparel';
  }
  return productCategory;
}

// eslint-disable-next-line complexity
const processResponse = (
  res,
  state,
  {
    isSearch,
    breadCrumbs,
    shouldApplyUnbxdLogic,
    getFacetSwatchImgPath,
    filtersAndSort,
    bucketingSeqConfig,
    getImgPath,
    excludeBadge,
    hasShortImage,
    isOutfitPage,
    searchTerm,
    sort,
    filterSortView,
    location,
    filterMaps = {},
    isLazyLoading,
    categoryFilterArray,
    isPrefetched,
    isRecommendationView,
    categoryNameList,
    brand,
    subSearchQuery,
    isRedirectFromNullSearch,
    isCleanUrlForSizeEnabled,
    isPromotionalUrl,
    isSLPNewTileImplementationEnabled,
  }
) => {
  let updatedUrl = '';
  const modifiedFiltersAndSort = filtersAndSort;
  const productCategory = getProductCategory(res.body);
  let redirectUrl = res.body.redirect && res.body.redirect.value;
  if (
    isClient() &&
    window.location &&
    window.location.href.includes('search') &&
    !isRedirectFromNullSearch
  ) {
    const searchRedirect = getSearchRedirectObj();
    if (searchRedirect && searchRedirect.redirectUrl !== window.location.href) {
      setSessionStorage({
        key: SEARCH_REDIRECT_KEY,
        value: JSON.stringify({ isDone: false, pc: productCategory }),
      });
    } else {
      setSessionStorage({
        key: SEARCH_REDIRECT_KEY,
        value: JSON.stringify({ ...searchRedirect, pc: productCategory }),
      });
    }
  }
  if (
    isClient() &&
    res.body.redirect &&
    typeof window !== 'undefined' &&
    !isRedirectFromNullSearch
  ) {
    if (redirectUrl)
      setSessionStorage({
        key: SEARCH_REDIRECT_KEY,
        value: JSON.stringify({ isDone: true, searchTerm, redirectUrl, pc: productCategory }),
      });
    try {
      // If domain matches try routing within the site else page reload is fine
      if (redirectUrl.length && redirectUrl.indexOf(window.location.hostname) > -1) {
        redirectUrl = redirectUrl.replace(window.location.origin, '');
        redirectUrl = redirectUrl.replace(/\/(us|ca)/, '');
        // Replaced routerPush with routerReplace, to prevent the redirect page to stack in the browser history.
        // For ELO-6391
        if (redirectUrl.indexOf('content') > -1) {
          const cid = redirectUrl.replace('/content/', '');
          routerReplace(`/content?contentType=${cid}`, redirectUrl); // try and avoid a hard reload
        } else {
          routerReplace(configureInternalNavigationFromCMSUrl(redirectUrl, true), redirectUrl, {
            shallow: true,
          });
        }
      } else {
        window.location.assign(redirectUrl);
      }
    } catch (e) {
      logger.error(e);
    }
  }

  if (
    isClient() &&
    filterSortView &&
    !isLazyLoading &&
    !isPrefetched &&
    !redirectUrl &&
    !isPromotionalUrl
  ) {
    updatedUrl = getPlpUrlQueryValues(filtersAndSort, location);
  }

  const pendingPromises = [];
  // flags if we are oin an L1 plp. Such plp's have no products, and only show espots and recommendations.
  const isDepartment = isDepartmentPage(isSearch, breadCrumbs);
  const attributesNames = processHelpers.getProductAttributes();
  const categoryType = isCategoryType(breadCrumbs);
  const l1category = getL1Category(breadCrumbs);
  let totalProductsCount = 0;
  let productListingCurrentNavIds;
  // We will get the avaialable l3 list in L2 page call in bucekting scenario.
  const availableL3List = getAvailableL3List(res.body.facets);
  const availableL3InFilter = getAppliedL3Filters(availableL3List);

  const displayToCustomerCategories =
    (categoryNameList &&
      categoryNameList[1] &&
      categoryNameList[1].subCategories &&
      categoryNameList[1].subCategories
        .filter((cat) => cat.displayToCustomer === false)
        .map(({ categoryId }) => categoryId)) ||
    [];

  totalProductsCount =
    (availableL3InFilter &&
      availableL3InFilter.reduce(
        (sum, item) =>
          (item && displayToCustomerCategories.indexOf(item.id) === -1 && item.count) + sum,
        0
      )) ||
    res.body.response.numberOfProducts;
  const toggleSearchSizeFilter = !!(totalProductsCount === 1 && isSearch && searchTerm);

  let filters = getFiltersAfterProcessing(
    res.body.facets,
    res.body.response.numberOfProducts,
    getFacetSwatchImgPath,
    modifiedFiltersAndSort,
    l1category,
    toggleSearchSizeFilter,
    res?.body?.stats,
    isCleanUrlForSizeEnabled
  );

  // This is the scenario when the subsequent L3 calls made in bucekting case. In this scenario we need to send back the filter and count, we cached
  // from the response of page L2 call.
  if (isUnbxdLogicApplied(shouldApplyUnbxdLogic, bucketingSeqConfig)) {
    // TODO - fix this - const { temp : { filters: newFilters, totalProductsCount:newTotalProductsCount }} = this.fetchCachedFilterAndCount();
    let productListingFilters = getProductsFilters(state);
    let productListingTotalCount = getTotalProductsCount(state);
    productListingCurrentNavIds = getCurrentListingIds(state);
    if (res.reqObj && res.reqObj.facetCallResponseState) {
      productListingFilters = res.reqObj.facetCallResponseState.filtersMaps;
      productListingTotalCount = res.reqObj.facetCallResponseState.totalProductsCount;
      productListingCurrentNavIds = res.reqObj.facetCallResponseState.currentNavigationIds;
    }
    filters = Object.keys(productListingFilters).length ? productListingFilters : filterMaps;
    totalProductsCount = productListingTotalCount || 0;
  }

  if (
    totalProductsCount === 1 &&
    isSearch &&
    searchTerm &&
    !isFiltered(filters) &&
    !subSearchQuery
  ) {
    const product = res.body.response.products && res.body.response.products[0];
    const productId = product && product.prodpartno;
    let productUrl = product && product.seo_token;
    if (!productUrl) {
      productUrl = productId;
    }
    const isBundleProduct = checkIfBundleProduct(product);

    let initialAsPathParam;
    let initialToPathParam;
    if (!isBundleProduct) {
      initialToPathParam = `/p?pid=`;
      initialAsPathParam = `/p/`;
    } else {
      initialToPathParam = `/b?bid=`;
      initialAsPathParam = `/b/`;
    }
    const queryParams = brand ? `&navigateType=direct$brand=${brand}` : `&navigateType=direct`;

    routerPush(
      `${initialToPathParam}${productUrl}${queryParams}`,
      `${initialAsPathParam}${productUrl}${queryParams}`,
      {
        shallow: false,
      }
    );
    return res;
  }

  // WHY DO WE NEED THIS??
  const unbxdId = res.headers && res.headers['unbxd-request-id'];
  // TODO - fix this - this.setUnbxdId(unbxdId);
  let entityCategory;
  let categoryNameTop = '';
  let bannerInfo = {};
  // Taking the first product in plp to get the categoryID to be sent to adobe
  if (processHelpers.hasProductsInResponse(res.body.response)) {
    const firstProduct = res.body.response.products[0];
    const categoryPath = processHelpers.getCategoryPath(firstProduct);
    const breadcrumbTopId = processHelpers.getBreadcrumbTopId(breadCrumbs);
    entityCategory = categoryPath
      ? processHelpers.parseCategoryEntity(categoryPath, breadCrumbs)
      : '';
    categoryNameTop = getCategoryId(categoryPath, breadcrumbTopId);
  }
  res.body.response.isSearch = isSearch;
  const response = {
    availableL3InFilter,
    currentListingSearchForText: processHelpers.getCurrentListingSearchForText(
      isSearch,
      searchTerm
    ),
    currentListingSeoKey: searchTerm,
    currentListingId: getCurrentListingId(breadCrumbs),
    currentListingName: categoryType,
    currentListingDescription: getCurrentListingDescription(breadCrumbs),
    currentListingType: getCurrentListingType(breadCrumbs), // need to store it because it will be needed to patch the information when getting additional product information
    isDepartment,
    // An L2 can be an outfits page, if so we need to store the 3rd party tag associated with this outfits page
    outfitStyliticsTag: getOutfitStyliticsTag(isOutfitPage, searchTerm), // DT-34042: dynamic outfit pages
    filtersMaps: filters,
    categoryModuleFilters: getModuleFilters(filters),
    quickFilter: extractQuickFiltersFromFilters(filters),
    appliedFiltersIds: processHelpers.getAppliedFilters(filters, modifiedFiltersAndSort),
    totalProductsCount,
    productsInCurrCategory: res.body.response.numberOfProducts,
    unbxdId,
    appliedSortId:
      isShopThisStoreModeOn() && Array.isArray(sort) && sort?.length > 0 ? sort[0] : sort,
    currentNavigationIds:
      productListingCurrentNavIds || processHelpers.getCurrentNavigationIds(res),
    breadCrumbTrail: processHelpers.getBreadCrumbTrail(breadCrumbs),
    loadedProductsPages: [[]],
    searchResultSuggestions: processHelpers.getSearchResultsSuggestion(res.body.didYouMean),
    unbxdBanners: processHelpers.getUnbxdBanners(res.body.banner),
    entityCategory,
    categoryNameTop,
    isSearch,
    redirect: res.body.redirect,
    updatedUrl,
    categoryFilterArray,
    seoHeaderCopy: getSeoHeaderCopyFromBreadCrumb(breadCrumbs),
    isBopisFilterOn: getIsBopisFilterOn(modifiedFiltersAndSort),
  };
  if (res.body.response) {
    const isUSStore = !isCanada();
    res.body.response.products.forEach((product) => {
      if (isSLPNewTileImplementationEnabled) {
        response.loadedProductsPages[0].push(product);
      } else {
        return parseProductInfo(product, state, {
          isUSStore,
          getImgPath,
          hasShortImage,
          attributesNames,
          categoryType,
          excludeBadge,
          bucketingSeqConfig,
          shouldApplyUnbxdLogic,
          response,
          res,
          isRecommendationView,
        });
      }
      return null;
    });
  }

  try {
    if (
      res.body.banner &&
      res.body.banner.banners &&
      res.body.banner.banners[0] &&
      res.body.banner.banners[0].bannerHtml
    ) {
      bannerInfo = JSON.parse(res.body.banner.banners[0].bannerHtml);
    }
  } catch (error) {
    logger.error(error);
  }
  return Promise.all(pendingPromises).then(() => {
    return { ...response, bannerInfo };
  });
};

export default processResponse;
